<script>
import ManageAllocationFormAccept from '../ManageAllocationFormAccept/ManageAllocationFormAccept.vue';
import ManageAllocationModalFormHeader from '../ManageAllocationModalFormHeader/ManageAllocationModalFormHeader.vue';
import {required, requiredIf} from 'vuelidate/lib/validators';
import {
    validateValidDate,
    validateMinNumber,
    beforeOrEqualTo,
    validateUpdateUnits
} from "../../services/ValidatorService";
import {mapState, mapActions} from 'vuex';

export default {
    components: {
        ManageAllocationFormAccept,
        ManageAllocationModalFormHeader
    },
    computed: {
        ...mapState({
            row: state => state.allocation.form.rows[0],
            loading: state => state.allocation.form.allocations.loading,
            error: state => state.allocation.form.allocations.error,
            noContent: state => state.allocation.allocations.noContent,
            validator: state => state.allocation.form.validator,
            accommodation: state => state.allocation.form.filters.selected.accommodation,
            selected: state => state.allocation.form.filters.selected,
            items: state => state.allocation.allocations.items,
            from: state => state.allocation.calendar.from,
            to: state => state.allocation.calendar.to
        }),
        fromClasses () {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.from.$dirty && this.$v.row.from.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.from.$dirty && !this.$v.row.from.$error
            }
        },
        toClasses () {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.to.$dirty && this.$v.row.to.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.to.$dirty && !this.$v.row.to.$error
            }
        },
        typeClasses () {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.type.$dirty && this.$v.row.type.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.type.$dirty && !this.$v.row.type.$error
            }
        },
        unitClasses () {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.units.$dirty && this.$v.row.units.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.units.$dirty && !this.$v.row.units.$error
            }
        },
        releaseTypeClasses () {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.releaseType.$dirty && this.$v.row.releaseType.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.releaseType.$dirty && !this.$v.row.releaseType.$error
            }
        },
        releaseMethodClasses () {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.releaseMethod.$dirty && this.$v.row.releaseMethod.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.releaseMethod.$dirty && !this.$v.row.releaseMethod.$error
            }
        },
        releaseDateClasses () {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.releaseDate.$dirty && this.$v.row.releaseDate.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.releaseDate.$dirty && !this.$v.row.releaseDate.$error
            }
        },
        releaseDaysClasses () {
            return {
                'manage-allocation-modal-form__input--error': this.$v.row.releaseDays.$dirty && this.$v.row.releaseDays.$error,
                'manage-allocation-modal-form__input--success': this.$v.row.releaseDays.$dirty && !this.$v.row.releaseDays.$error
            }
        },
    },
    methods: {
        ...mapActions({
            setModalRow: 'allocation/setModalRow',
            validateInputs: 'allocation/validateAddAllocationInputs',
            submit: 'allocation/submitForm',
            resetForm: 'allocation/resetModalForm',
            addAllocations: 'allocation/addAllocations',
            toggleAddAllocation: 'allocation/toggleModalAddAllocations',
            getAllocationList: 'allocation/getAllocationList',
            getAllocationListMerged: 'allocation/getAllocationListMerged',
            getAllocationCalendar: 'allocation/getAllocationCalendar'
        }),
        update (obj) {
            this.$v.$touch();
            // Set the from and to dates on the row object
            this.setModalRow({...this.row, ...obj});
        },
        submitForm () {
            this.$v.$touch();
            this.validateInputs();
            // If input fields are invalid then its not possible to submit
            if (!this.validator.error) {
                this.submit([]);
            }
        }
    },
    validations() {
        return {
            row: {
                type: {
                    required
                },
                units: {
                    required: requiredIf((nestedRow) => {
                        return nestedRow.type === 'ALLOTMENT'
                    }),
                    validateMinNumber: (units, allocation) => {
                        return allocation.type === 'ALLOTMENT' ? validateMinNumber(units) : true;
                    },
                    ValidateUnits: (units) => {
                        let valid = validateUpdateUnits(units, this.row);
                        if (!valid.valid) {
                            this.errors = valid.message;
                        }
                        return valid.valid;
                    },
                },
                releaseType: {
                    required
                },
                releaseMethod: {
                    required
                },
                releaseDays: {
                    required: requiredIf((nestedRow) => {
                        return nestedRow.releaseMethod === 'days'
                    }),
                    validateMinNumber: (days, allocation) => {
                        return allocation.releaseMethod === 'days' ? validateMinNumber(days) : true;
                    }
                },
                releaseDate: {
                    required: requiredIf((nestedRow) => {
                        return nestedRow.releaseMethod === 'date'
                    }),
                    validateValidDate: (date, allocation) => {
                        return allocation.releaseMethod === 'date' ? validateValidDate : true;
                    },
                    beforeOrEqualTo: (date, allocation) => {
                        return allocation.releaseMethod === 'date' ? beforeOrEqualTo(date, allocation) : true;
                    }
                }
            }
        }
    }
}
</script>
<template>
    <div class="manage-allocation-modal-form">
        <div class="manage-allocation-modal-form__content">
            <manage-allocation-form-accept
                :label="'Adding allocations'"
                :method="'add'"
                @accept="addAllocations"/>
            <manage-allocation-modal-form-header/>
            <div class="manage-allocation-modal-form__fields">
                <div class="manage-allocation-modal-form__field">
                    <select v-model="row.type"
                            :class="typeClasses"
                            :value="row.type"
                            class="manage-allocation-modal-form__dropdown"
                            @input="update({type: $event.target.value})">
                        <option value="ALLOTMENT">
                            {{ $t('manageAllocationModal.form.type.allotment') }}
                        </option>
                        <option value="FREESALE">
                            {{ $t('manageAllocationModal.form.type.freesale') }}
                        </option>
                    </select>
                </div>
                <div class="manage-allocation-modal-form__field">
                    <input v-number-only
                           :class="unitClasses"
                           :value="row.units"
                           :disabled="row.type === 'FREESALE' || row.type === '' || !row.type"
                           :placeholder="row.type === 'ALLOTMENT' ? $t('manageAllocationModal.form.units.allotment') : $t('manageAllocationModal.form.units.notAllotment')"
                           type="text"
                           class="manage-allocation-modal-form__input"
                           @input="update({units: $event.target.value})">
                </div>
                <div class="manage-allocation-modal-form__field">
                    <select v-model="row.releaseMethod"
                            :value="row.releaseMethod"
                            :class="releaseMethodClasses"
                            class="manage-allocation-modal-form__dropdown"
                            @input="update({releaseMethod: $event.target.value})">
                        <option value="days">
                            {{ $t('manageAllocationModal.form.releaseMethod.days') }}
                        </option>
                        <option value="date">
                            {{ $t('manageAllocationModal.form.releaseMethod.date') }}
                        </option>
                    </select>
                </div>
                <div class="manage-allocation-modal-form__field">
                    <input v-mask="'##/##/####'"
                           v-if="row.releaseMethod === 'date'"
                           :placeholder="$t('manageAllocationModal.form.date')"
                           :value="row.releaseDate"
                           :class="releaseDateClasses"
                           type="text" class="manage-allocation-modal-form__input"
                           @input="update({releaseDate: $event.target.value, releaseDays: undefined})">
                    <input v-number-only
                           v-if="row.releaseMethod === 'days'"
                           :placeholder="$t('manageAllocationModal.form.days')"
                           :value="row.releaseDays"
                           :class="releaseDaysClasses"
                           type="text" class="manage-allocation-modal-form__input"
                           @input="update({releaseDays: $event.target.value, releaseDate: undefined})">
                </div>
                <div class="manage-allocation-modal-form__field">
                    <select v-model="row.releaseType"
                            :value="row.releaseType"
                            :class="releaseTypeClasses"
                            class="manage-allocation-modal-form__dropdown"
                            @input="update({releaseType: $event.target.value})">
                        <option :value="undefined">
                            {{ $t('manageAllocationModal.form.releaseType.selectType') }}
                        </option>
                        <option :value="'REQUEST'">
                            {{ $t('manageAllocationModal.form.releaseType.request') }}
                        </option>
                        <option :value="'FREESALE'">
                            {{ $t('manageAllocationModal.form.releaseType.freesale') }}
                        </option>
                        <option :value="'BLOCKED'">
                            {{ $t('manageAllocationModal.form.releaseType.blocked') }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="manage-allocation-modal-form__control-buttons">
                <button :disabled="loading || this.$v.$error"
                        class="manage-allocation-modal-form__submit"
                        @click="submitForm">
                    {{ $t('manageAllocationModal.form.buttons.create') }}
                </button>
                <button :disabled="loading"
                        class="manage-allocation-modal-form__reset"
                        @click="toggleAddAllocation">
                    {{ $t('manageAllocationModal.form.buttons.cancel') }}
                </button>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationModalForm/ManageAllocationModalForm.vue